<template>
  <section id="faq">
    <div id="breadcrumbs">
      <div class="bg-light py-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-0 text-left">
              <router-link to="/">Home</router-link>
              <span class="mx-2 mb-0">/</span>
              <strong class="text-black">Faq's</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #breadcrumbs -->
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-0">
            <h3 class="text-center mt-4">Preguntas frecuentes</h3>
            <div class="row">
              <div class="col-lg-6">
                <div class="accordion" role="tablist">
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-1
                      >¿Cómo actualizo mi informacion personal?
                      <span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>
                    <b-collapse
                      id="accordion-1"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Hay dos formas muy simples. Inicia sesión en tu
                          cuenta, da clic en tu perfil y después al apartado
                          usuario o si lo prefieres, puedes contactarnos a
                          suscripciones@revistamoi.com o sos@revistamoi.com
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-2
                      >¿Cómo veo mi revista Digital?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>
                    <b-collapse
                      id="accordion-2"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          Tu revista Digital la puedes visualizar desde nuestra
                          página web a partir del lanzamiento de la misma.
                        </b-card-text>
                        <b-card-text>
                          Ingresa a tu sesión, da clic en tu perfil e ingresa al
                          apartado de revista digital
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-3
                      >¿En cuánto tiempo me llega mi revista digital?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>El día del lanzamiento de la revista</b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-4
                      >¿Llega por mail mi revista Digital?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-4"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Cada mes recibiras tu revista digital por correo, te
                          recomedamos revisar en tu perfil que tu correo sea
                          correcto
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-5
                      >¿Cómo sé el estatus de mi envío?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-5"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Tu envío tiene un tiempo promedio de entrega de 10
                          días habiles, es decir, los primeros de cada mes. Si
                          pasado este tiempo no llega, podrás enviar un
                          comentario a suscripciones@revistamoi.com o
                          sos@revistamoi.com. En caso de que no se te localice
                          en tu domicilio, se regresará a la oficina postal y se
                          levantará un reporte para generar el reenvio de la
                          misma
                        </b-card-text>
                        <b-card-text
                          >Para saber dónde se encuentra tu revista MOI
                          contactanos a suscripciones@revistamoi.com o
                          sos@revistamoi.com y con gusto te darán los avances de
                          tu entrega. El tiempo de entrega aproximado es de 10
                          dias hábiles, recuerda que este tiempo puede variar
                          dependiendo de dónde te encuentres.
                        </b-card-text>
                        <b-card-text
                          >Recuerda que tenemos 10 ediciones al año. Dos
                          ediciones son bimestrales la de Verano (junio-julio) e
                          invierno (diciembre-enero)
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-6
                      >¿Si no me llega confirmación o no puedo ver mi
                      suscripción con quién me comunico?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-6"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Cuando generas una suscripción se te envía una
                          confirmación y te detalla lo que compraste (revista, o
                          revista + alegría) . Si no te llega la confirmación
                          puedes enviar correo a suscripciones@revistamoi.com o
                          sos@revistamoi.com
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-7
                      >¿Cómo se que me suscribí correctamente?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-7"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          A tu correo te llegará una confirmación de
                          suscripción. En caso de no recibir este correo puedes
                          contactar a nuestro equipo de suscriciones en
                          suscripciones@revista moi.com o sos@revistamoi.com
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-8
                      >¿Si no llega mi revista dónde lo reporto?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-8"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Ponte en contacto con nostros a
                          suscripciones@revistamoi.com o sos@revistamoi.com o al
                          Tel: 5591262230 ellos con mucho gusto te ayudarán a
                          dar seguimiento a tu reporte
                        </b-card-text>
                        <b-card-text
                          >Recuerda que tenemos 10 ediciones al año. Dos
                          ediciones son bimestrales la de Verano (junio-julio) e
                          invierno (diciembre-enero)
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-9
                      >¿Dónde puedo recuperar mi contraseña para iniciar mi
                      sesión?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-9"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >ingresa a nuestro portal de suscripciones, ve a
                          iniciar sesión y ahí das clic para recuperar la
                          contraseña
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="accordion" role="tablist">
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-10
                      >¿Cómo funciona el envío ordinario y registrado?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-10"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Tenemos 2 formas de hacerte llegar tu revista.
                          Ordinario: consiste en que la mensajería acudirá a tu
                          domicilio y realizará la entrega bajo puerta y buzón.
                          Registrada: la mensajeria acudirá al domicilio y
                          tocará a tu puerta para que pueda ser recibida con
                          firma. Puede recibir cualquier persona que se
                          identifique dentro del domicilio citado, si no hay
                          alguien que pueda recibir, la paquetería hará dos
                          intentos y de no tener éxito, devolverá la revista.
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-11
                      >¿Cuáles son los metodos de envio?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-11"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>Ordinario y Registrado </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-12
                      >¿Si me suscribo en qué mes llegará mi primera
                      edición?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-12"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Siempre y cuando te suscribas antes del dia 20 del
                          mes que corre, te llegará tu ejemplar de ese mes,
                          ejemplo: si te suscribes el 19 de Noviembre te llegara
                          tu ejemplar de diciembre, si lo haces el 20 de
                          Noviembre tu primer ejemplar será el de febrero
                          (diciembre - enero) es bimestral
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-13
                      >¿Como comprar una suscripción?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-13"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Deberás de dirigirte a la página oficial de MOI , das
                          click en el baner principal, regístrate, crea tu
                          cuenta, realiza el pago y listo. También puedes seguir
                          las últimas novedades y promociones de la revista en
                          las principales redes sociales
                        </b-card-text>
                        <b-card-text
                          >Da clic en nuestro portal
                          https://products.mmkgroup.com.mx/ o contáctanos a
                          los correos suscripciones@revistamoi.com y
                          sos@revistamoi.com o al tel:5591262224 todo el equipo
                          de MOI tramitará tus peticiones a la mayor brevedad
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-14
                      >¿Cómo puedo comprar Anuario o Ediciones anteriores?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-14"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Deberás de dirigirte a la página oficial de MOI ,
                          selecciona el producto, regístrate, crea tu cuenta,
                          donde dice nombre de envío o suscripción pon el nombre
                          del tercero, paga y listo. Todo el equipo de MOI
                          tramitará tus peticiones a la mayor brevedad. También
                          puedes seguir las últimas novedades y promociones de
                          la revista en las principales redes sociales
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-15
                      >¿Cómo puedo comprar una suscripción para un tercero, o
                      dos nombre en una suscripción?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-15"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >Deberás de dirigirte a la página oficial de MOI , das
                          click en el baner principal, regístrate, crea tu
                          cuenta, donde dice nombre de envío o suscripción pon
                          el nombre del tercero, paga y listo. Todo el equipo de
                          MOI tramitará tus peticiones a la mayor brevedad.
                          También puedes seguir las últimas novedades y
                          promociones de la revista en las principales redes
                          sociales
                        </b-card-text>
                        <b-card-text
                          >Da clic en nuestro portal
                          https://products.mmkgroup.com.mx/ o contáctanos a
                          los correos suscripciones@revistamoi.com y
                          sos@revistamoi.com o al tel:5591262224 todo el equipo
                          de MOI tramitará tus peticiones a la mayor brevedad
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <b-card no-body class="my-3">
                    <b-button class="pr-4" block variant="secondary" v-b-toggle.accordion-16
                      >¿Cuántas ediciones tenemos al año?<span
                        style="position: absolute; right: 5px; top: 25%"
                        class="icon-arrow-down"
                      ></span
                    ></b-button>

                    <b-collapse
                      id="accordion-16"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >10 ediciones al año, tenemos 2 ediciones bimestrales
                          (jun/jul y dic/ene)
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "faq",
};
</script>

<style>
</style>